<div class="financial-overview-card">
  <!-- Header with Toggle -->
  <div class="card-header">
    <h3 class="card-title">Financial Overview</h3>
    <div class="toggle-container">
      <span class="toggle-label">Scope View</span>
      @if (scopeChartView) {
        <img src="../../../../../assets/img/general_icons/chartview.svg" alt="chart view icon"
          (click)="onToggleChange($event)">
      }
      @if (!scopeChartView) {
        <img src="../../../../../assets/img/general_icons/chartview-active.svg" alt="chart view active icon"
          (click)="onToggleChange($event)">
      }
    </div>
  </div>

  <!-- Chart Section -->
  <div class="chart-section">
    <div class="chart-container">
      <app-echart (chartInstance)="getChartInstance($event)"></app-echart>
      <!-- Center Content Overlay -->
      <div class="chart-center-content">
        <div class="completion-percentage">{{chartValueLabel}}</div>
        <div class="center-amount">{{centerDisplayAmount}}</div>
      </div>
    </div>
  </div>

  <!-- KPI Metrics Section -->
  <div class="kpi-metrics">
    @if (isFinancialOverviewInvoiced) {
      <div class="kpi-item">
        <div class="kpi-label">INVOICED</div>
        <div class="kpi-value">{{invoicedAmount}}</div>
        <div class="kpi-percentage">({{invoicedPercentage}}%)</div>
      </div>
    }
    @if (isFinancialOverviewRemaining) {
      <div class="kpi-item">
        <div class="kpi-label">
          REMAINING
          <!-- R icon for retainage info -->
          @if (retainagePercent > 0) {
            <span class="retainage-indicator"
              [title]="'Includes Retainage: ' + retainageDisplay + ' (' + retainagePercent + '%)'">
              R
            </span>
          }
        </div>
        <div class="kpi-value">{{remainingAmount}}</div>
        <div class="kpi-percentage">({{remainingPercentage}}%)</div>
        <!-- Show retainage breakdown -->
        @if (retainagePercent > 0) {
          <div class="kpi-retainage">
            <small>RETAINAGE: <b>{{retainageDisplay}}</b></small>
          </div>
        }
      </div>
    }
  </div>

  <!-- Payment Progress Bar -->
  @if (isFinancialOverviewInvoicePercentage) {
    <div class="payment-progress">
      <div class="progress-bar-container">
        <div class="progress-bar" [style.width.%]="invoicedPercentage"></div>
      </div>
      <div class="progress-text">{{invoicedPercentage}}% Complete</div>
    </div>
  }

  <!-- Active Buyout Warning -->
  @if (this.model?.activate_buyout == 1) {
    <div class="buyout-warning">
      <img src="../../../../../../assets/img/sales/proposal-edit/danger-icon.png" width="20" alt="warning icon">
      <span>Active Buyout</span>
    </div>
  }
</div>